<script setup lang="ts">
import breadcrumb from '#layers/ui/theme/components/breadcrumb';
</script>

<template>
	<span :class="breadcrumb.slots.separator">/</span>
</template>
